import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { RentDisclaimer } from "web_myplann/Goals/Components/RentPlan/RentDisclaimer";
import { RentPhaseDescriptions } from "web_myplann/Goals/Components/RentPlan/RentPhaseDescriptions";
import { RentTimelineBar } from "web_myplann/Goals/Components/RentPlan/RentTimelineBar";
import { RentTimelineYears } from "web_myplann/Goals/Components/RentPlan/RentTimelineYears";
import { useRentPlan } from "web_myplann/Goals/Hooks/useRentPlan";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CollapsibleSection } from "web_myplann/Shared/Components/CollapsibleSection";

type Props = {
	goal: GoalDetail;
};

export const GoalDetailRentPlan: FC<Props> = ({ goal }) => {
	const theme = useTheme();
	const { t } = useResource();
	const plan = useRentPlan(goal);

	if (!plan) return null;

	return (
		<CollapsibleSection title={t(Resources.Goals.Detail.RentPlan.title)}>
			<Stack bgcolor={theme.palette.background.paper} px={2} py={2.5} gap={2}>
				<RentTimelineBar
					accumFlex={plan.accumFlex}
					drawFlex={plan.drawFlex}
					isPerpetual={plan.isPerpetual}
				/>
				<RentTimelineYears plan={plan} />
				<RentPhaseDescriptions plan={plan} />
				<RentDisclaimer />
			</Stack>
		</CollapsibleSection>
	);
};
